import { serviceOperationApi } from "./api";

const TALLER_TABLES = [
  "taller_componente",
  "taller_deposito_destino",
  "taller_descripcion",
  "taller_estado_sku",
  "taller_estetica_packaging",
  "taller_estetica_producto",
  "taller_falla",
  "taller_lote",
  "taller_motivo_del_scrap",
  "taller_reparacion",
  "taller_responsable",
];

const toUniqueActive = (items) => {
  const seen = new Set();
  return items.filter((item) => {
    if (!item.active || seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
};

export async function fetchTallerFormLookups({ accessToken, countryId }) {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const responses = await Promise.all(
    TALLER_TABLES.map((table) =>
      serviceOperationApi.get("/Data", {
        params: { table, country_id: countryId },
        headers,
      }),
    ),
  );

  return Object.fromEntries(
    TALLER_TABLES.map((table, idx) => [
      table,
      toUniqueActive(responses[idx].data),
    ]),
  );
}